import { render, staticRenderFns } from "./specialized-new-zone-shop.vue?vue&type=template&id=29790181&scoped=true"
import script from "./specialized-new-zone-shop.vue?vue&type=script&lang=js"
export * from "./specialized-new-zone-shop.vue?vue&type=script&lang=js"
import style0 from "./specialized-new-zone-shop.vue?vue&type=style&index=0&id=29790181&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29790181",
  null
  
)

export default component.exports